import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { LayoutType } from '../../models/layout-type';
import { LayoutTypeService } from '../../services/layout-type.service';
import { Router } from '@angular/router';
import { ListForm } from '../../../../base/controlers/list-form';

@Component({
  selector: 'app-layout-type-list',
  templateUrl: './layout-type-list.component.html',
  styleUrls: ['./layout-type-list.component.css']
})
export class LayoutTypeListComponent extends ListForm<LayoutType> implements OnInit {
  
  public displayedColumns = ['actions','code','name', 'price'];
  constructor(
    protected layoutTypeService: LayoutTypeService,
    protected router:Router
  ) {
    super(layoutTypeService,'/plasard-measurement/layout-type',router);
   }
  ngOnInit() {
    super.ngOnInit();
  }
}
